import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import AuthProvider from "./components/auth-provider";
import InitializeAmplify from "./components/initialize-amplify";

// biome-ignore lint/style/noNonNullAssertion: <explanation>
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <InitializeAmplify />
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
